module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/main-visual_stay-6500cc35e6143a037e56e64f9237fdd2.webp";